/* eslint max-len: ["error", { "code": 90 }] */


/**
 * MUDANÇA: Renomeado de 'limparPontuacoesCPF' para 'sanitizeCpf' para padronizar.
 * Remove todos os caracteres não numéricos de uma string de CPF.
 * @param {string} cpf - O CPF com ou sem formatação.
 * @return {string} - Apenas os números do CPF.
 */
const sanitizeCpf = (cpf) => {
  if (!cpf) return "";
  return String(cpf).replace(/\D/g, "");
};

/**
 * MUDANÇA: Lógica alterada para retornar um booleano (true/false),
 * que é o que o backend espera.
 * Valida um número de CPF.
 * @param {string} cpfStr - A string do CPF (com ou sem máscara).
 * @return {boolean} - Retorna `true` se o CPF for válido, `false` caso contrário.
 */
const isValidCpf = (cpfStr) => {
  const cpf = sanitizeCpf(cpfStr);
  if (!cpf || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};

/**
 * NOVO: Mantivemos a função que retorna mensagem para uso no frontend.
 * Valida um CPF e retorna uma mensagem de erro específica.
 * @param {string} cpfStr - A string do CPF.
 * @return {string} - Retorna uma string de erro se inválido, ou string vazia se válido.
 */
const validateCpfWithMessage = (cpfStr) => {
  const cpf = sanitizeCpf(cpfStr);
  if (!cpf) return "Digite seu CPF.";
  if (!isValidCpf(cpf)) return "Digite um CPF válido.";
  return "";
};

/**
 * MANTIDO: Esta função é útil para a máscara de input no frontend.
 * Formata um valor numérico para o padrão de CPF (XXX.XXX.XXX-XX).
 * @param {string} value - O valor a ser formatado.
 * @return {string} - O CPF formatado.
 */
const formatCPF = (value) => {
  let cleaned = sanitizeCpf(value);
  if (cleaned.length > 11) {
    cleaned = cleaned.substring(0, 11);
  }
  cleaned = cleaned.replace(/(\d{3})(\d)/, "$1.$2");
  cleaned = cleaned.replace(/(\d{3})(\d)/, "$1.$2");
  cleaned = cleaned.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return cleaned;
};

/**
 * Máscara de EXIBIÇÃO (≠ formatCPF, que é máscara de DIGITAÇÃO): ***.456.789-**
 *
 * Padrão da Receita Federal. Some com o começo e com os dígitos verificadores,
 * que são justamente as partes que permitem reconstruir o número. O miolo basta
 * para a pessoa se reconhecer ("é o meu mesmo") sem que a tela sirva de
 * confirmação para quem apenas chutou o CPF de outra pessoa.
 * @param {string} raw - CPF com ou sem máscara.
 * @return {string} - Vazio se não forem 11 dígitos.
 */
const ocultarCpf = (raw) => {
  const d = sanitizeCpf(raw);
  if (d.length !== 11) return "";
  return `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**`;
};

export {
  sanitizeCpf, isValidCpf, validateCpfWithMessage, formatCPF, ocultarCpf,
};